module.exports = __webpack_public_path__ + "img/bannertest.1aedeb9d.jpg";